import { Divider, Flex } from '@chakra-ui/layout';
import { DrawerFooter } from '@chakra-ui/modal';
import { FormButton } from 'library/atoms';
import { useFormContext } from 'react-hook-form';
import { IncidentAnalyticsFilterForm } from 'views/main/organization/analytics-v3/hooks/types';
import { useAnalyticsV3Context } from 'views/main/organization/analytics-v3/hooks/useAnalyticsV3Context';

const FilterFormFooter = () => {
  const setIsFilterDrawerOpen = useAnalyticsV3Context(state => state.setIsFilterDrawerOpen);
  const { watch, setValue } = useFormContext<IncidentAnalyticsFilterForm>();

  const disableClearAllButton = false;

  const isFiltersApplied =
    watch('tagKey') ||
    watch('tagValue') ||
    watch('priority') ||
    watch('assignee') ||
    watch('serviceOwner') ||
    watch('service');

  const onClearAll = () => {
    setValue('tagKey', null);
    setValue('tagValue', []);
    setValue('priority', []);
    setValue('assignee', {
      users: [],
      squads: [],
      myUsers: [],
      mySquads: [],
      meAndMySquads: false,
    });
    setValue('serviceOwner', {
      users: [],
      squads: [],
      myUsers: [],
      mySquads: [],
      meAndMySquads: false,
    });
    setValue('service', []);
  };

  return (
    <Flex direction="column">
      <Divider />
      <DrawerFooter gap="20px" justifyContent={'flex-start'}>
        <FormButton variant="primary" type="submit" aria-label="submit" title="Apply" />
        <FormButton
          variant="secondary"
          onClick={() => setIsFilterDrawerOpen(false)}
          title="Cancel"
        />
        <FormButton
          disabled={disableClearAllButton}
          variant="ghost"
          onClick={onClearAll}
          title="Clear All"
        />
      </DrawerFooter>
    </Flex>
  );
};

export default FilterFormFooter;
